/**
 * Copyright 2022-2023 Nordcloud Oy or its affiliates. All Rights Reserved.
 */

import { useFormContext } from "react-hook-form";
import { Checkbox, FlexContainer, Label, Text, theme } from "@nordcloud/gnui";
import { FormGroup } from "~/components";
import { WorkflowFormData } from "~/views/workflows/types";
import { PreviewButton } from "../../EmailSettingsForm/PreviewButton";
import { parseFieldErrors } from "./utils";

type Props = {
  isReadMode: boolean;
  onPreviewClick: () => void;
};

export function SavingSuggestionsOptionsDataTypeField({
  isReadMode,
  onPreviewClick,
}: Props) {
  const {
    register,
    formState: { errors },
  } = useFormContext<WorkflowFormData>();
  const { savingSuggestionsError } = parseFieldErrors(errors);

  return (
    <>
      <FlexContainer
        paddingBottom={theme.spacing.spacing02}
        alignItems="center"
        justifyContent="space-between"
      >
        <Label
          css={{ marginBottom: theme.spacing.spacing00, textTransform: "none" }}
          name="Select Data Type(s)"
          required={!isReadMode}
        />
        <PreviewButton type="button" size="sm" onClick={() => onPreviewClick()}>
          Sample Message
        </PreviewButton>
      </FlexContainer>
      <Text size="sm" color={theme.color.text.text02}>
        Savings suggestions for each Business Context, Organizational Unit,
        application, and environment will be combined. Please select one or more
        data types which will be located in a ServiceNow field.
      </Text>
      <FormGroup error={savingSuggestionsError}>
        <Checkbox
          disabled={isReadMode}
          {...register(
            "serviceNow.savingSuggestionsOptions.totalMonthlySavings"
          )}
          labelText="Total Monthly Savings"
        />
        <Checkbox
          disabled={isReadMode}
          {...register(
            "serviceNow.savingSuggestionsOptions.monthlySavingsByProviders"
          )}
          labelText="Total Monthly Savings By Providers"
        />
        <Checkbox
          disabled={isReadMode}
          {...register(
            "serviceNow.savingSuggestionsOptions.monthlySavingsByCategories"
          )}
          labelText="Total Monthly Savings By Categories"
        />
        <Checkbox
          disabled={isReadMode}
          {...register(
            "serviceNow.savingSuggestionsOptions.monthlySavingsByPolicies"
          )}
          labelText="Total Monthly Savings By Policies"
        />
      </FormGroup>
    </>
  );
}
